import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DebugPage, useOneOf, useToggles } from './../../app/DebugPage';
import * as React from 'react';
import { useNavigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import * as Common from '_common';
import * as Components from '_components';
import * as Utils from '_utils';
import * as Styles from './Button.module.scss';
function getClasses(props, isLink = false) {
    let classNames = {
        [Styles.btn]: !isLink,
        [Styles.primary]: props.isPrimary || false,
        [Styles.active]: props.isActive || false,
        [Styles.not_active]: props.isActive === false,
    };
    classNames = Common.WithCommonProps(props, classNames);
    classNames = Components.WithTileProps(props, classNames);
    return Utils.classNames(classNames);
}
export function Button(props) {
    const classes = getClasses(props);
    let content = props.children;
    if (props.icon) {
        content = (_jsxs(_Fragment, { children: [_jsx("span", { className: Styles.icon, children: props.icon }), props.children] }));
    }
    return (_jsx("button", { className: classes, disabled: props.isDisabled, onClick: props.onClick, children: content }));
}
export function SubmitButton(props) {
    const classes = getClasses(props);
    let content = props.children;
    if (props.icon) {
        content = (_jsxs(_Fragment, { children: [_jsx("span", { className: Styles.icon, children: props.icon }), props.children] }));
    }
    return (_jsx("button", { type: "submit", className: classes, disabled: props.isDisabled, onClick: props.onClick, children: content }));
}
export function ButtonLink(props) {
    const classes = getClasses(props);
    if (!props.to) {
        return _jsx(_Fragment, { children: props.children });
    }
    if (props.to?.startsWith('/')) {
        return (_jsx(NavLink, { className: classes, to: props.to, children: props.children }));
    }
    else {
        return (_jsx("a", { className: classes, href: props.to, children: props.children }));
    }
}
export function Link(props) {
    const classes = getClasses(props, true);
    if (!props.to) {
        return _jsx(_Fragment, { children: props.children });
    }
    if (props.to?.startsWith('/')) {
        return (_jsx(NavLink, { className: classes, to: props.to, children: props.children }));
    }
    else {
        return (_jsx("a", { className: classes, href: props.to, children: props.children }));
    }
}
export function NavButton(props) {
    const navigate = useNavigate();
    function onClick() {
        if (props.target.includes('/')) {
            navigate(props.target);
        }
        else {
            navigate('/Page/' + props.target);
        }
    }
    return (_jsx(Button, { ...props, onClick: onClick, children: props.children }));
}
export function NavButtonRender(component, index) {
    return (_jsxs(NavButton, { ...component.properties, children: [' ', _jsx(Components.SimpleComponentContent, { component: component })] }, index));
}
export function Toggle(props) {
    function toggle() {
        if (props.onChange) {
            props.onChange(!props.checked);
        }
    }
    return (_jsx(Button, { ...props, isActive: props.checked, onClick: toggle, children: props.children }));
}
function DummyToggle(props) {
    const [value, setValue] = React.useState(false);
    return (_jsx(Toggle, { ...props, checked: value, onChange: setValue, children: props.children }));
}
export function useToggle(props) {
    const [value, setValue] = React.useState(props.checked || false);
    const cmp = (_jsx(Toggle, { ...props, checked: value, onChange: setValue, children: props.children }));
    return [value, cmp];
}
export var BtnGroupType;
(function (BtnGroupType) {
    BtnGroupType[BtnGroupType["Horizontal"] = 0] = "Horizontal";
    BtnGroupType[BtnGroupType["Vertical"] = 1] = "Vertical";
    BtnGroupType[BtnGroupType["Grid"] = 2] = "Grid";
})(BtnGroupType || (BtnGroupType = {}));
export function BtnGroup(props) {
    const classes = Utils.classNames({
        [Styles.grp_horizontal]: props.type === BtnGroupType.Horizontal,
        [Styles.grp_vertical]: props.type === BtnGroupType.Vertical,
        [Styles.grp_grid]: props.type === BtnGroupType.Grid,
        [Styles.grp_small]: props.small,
    });
    return (_jsx(Common.Component, { name: 'btn-group', className: classes, children: props.children }));
}
export function RenderButton(component, index) {
    return (_jsx(Button, { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function RenderButtonGroup(component, index) {
    return (_jsx(BtnGroup, { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function ButtonsDebug(component, index) {
    const [toggles, togglesControls] = useToggles({
        isPrimary: false,
        isActive: false,
        isDisabled: false,
    });
    const [group, groupControls] = useOneOf(['None', 'Horizontal', 'Vertical', 'Grid']);
    const [type, typeControls] = useOneOf(['Simple', 'Toggle', 'Complex']);
    const controls = (_jsxs(_Fragment, { children: [togglesControls, _jsx("h3", { children: "Group" }), groupControls, _jsx("h3", { children: "Type" }), typeControls] }));
    function createButton(text) {
        if (type === 'Simple') {
            return _jsx(Button, { ...toggles, children: text });
        }
        if (type === 'Toggle') {
            return _jsx(DummyToggle, { ...toggles, children: text });
        }
    }
    const btns = (_jsxs(_Fragment, { children: [createButton('Btn 1'), createButton('Btn 22'), createButton('Btn 333'), createButton('Btn 4444')] }));
    function createGroup() {
        if (group === 'None') {
            return btns;
        }
        function getGrpType() {
            switch (group) {
                case 'Horizontal':
                    return BtnGroupType.Horizontal;
                case 'Vertical':
                    return BtnGroupType.Vertical;
                case 'Grid':
                    return BtnGroupType.Grid;
            }
        }
        const type = getGrpType();
        return _jsx(BtnGroup, { type: type, children: btns });
    }
    return _jsx(DebugPage, { controls: controls, children: createGroup() });
}
export function Gap() {
    return _jsx("span", { className: Styles.gap });
}
